import React from 'react';
import { motion } from 'framer-motion';

const DentalAnimation = () => {
  const trailingTeeth = [
    { scale: 0.7, xOffset: -8, yOffset: 6, radius: 1.2 },
    { scale: 0.65, xOffset: 6, yOffset: -8, radius: 1.1 },
    { scale: 0.55, xOffset: -12, yOffset: -4, radius: 1.0 },
    { scale: 0.45, xOffset: 10, yOffset: 8, radius: 0.9 },
    { scale: 0.35, xOffset: -15, yOffset: -6, radius: 0.8 }
  ];

  const baseMovement = {
    x: [
      '-3vw',
      '-6vw',
      '-1vw',
      '2vw',
      '-4vw',
      '3vw',
      '-2vw',
      '-5vw',
      '-3vw'
    ],
    y: [
      '-4vh',
      '-8vh',
      '-2vh',
      '-6vh',
      '-1vh',
      '-7vh',
      '-3vh',
      '-5vh',
      '-4vh'
    ],
    rotate: [
      0,
      -8,
      10,
      -5,
      8,
      -6,
      9,
      -7,
      0
    ]
  };

  return (
    <>
      {trailingTeeth.map(({ scale, xOffset, yOffset, radius }, index) => (
        <motion.div
          key={index}
          className="absolute"
          style={{
            top: `calc(10% + ${yOffset}vh)`,
            left: `calc(30% + ${xOffset}vw)`,
            transform: 'translate(-50%, -50%)',
            width: '200px',
            height: '200px',
            zIndex: -index
          }}
          animate={{
            x: baseMovement.x.map(x => `calc(${x} + ${xOffset * 0.15}vw)`),
            y: baseMovement.y.map(y => `calc(${y} + ${yOffset * 0.15}vh)`),
            rotate: baseMovement.rotate.map(r => r * (0.7 + index * 0.15))
          }}
          transition={{
            duration: 45,
            repeat: Infinity,
            ease: "easeInOut",
            times: [0, 0.1, 0.25, 0.35, 0.5, 0.65, 0.75, 0.9, 1],
            delay: index * 0.8
          }}
        >
          <motion.img
            src="/tooth.svg"
            alt="Tooth"
            className="w-full h-full mix-blend-multiply dark:mix-blend-screen blur-[2px]"
            style={{
              opacity: scale * 0.104,
              transform: `scale(${scale})`,
            }}
            animate={{
              rotate: [-3, 3, -3],
              scale: [scale * 0.95, scale * 1.05, scale * 0.95]
            }}
            transition={{
              duration: 6 + index,
              repeat: Infinity,
              ease: "easeInOut",
              delay: index * 0.5
            }}
          />
        </motion.div>
      ))}
      <motion.div
        className="absolute"
        style={{
          top: '10%',
          left: '30%',
          transform: 'translate(-50%, -50%)',
          width: '200px',
          height: '200px',
          zIndex: 1
        }}
        animate={{
          x: baseMovement.x,
          y: baseMovement.y,
          rotate: baseMovement.rotate
        }}
        transition={{
          duration: 45,
          repeat: Infinity,
          ease: "easeInOut",
          times: [0, 0.1, 0.25, 0.35, 0.5, 0.65, 0.75, 0.9, 1]
        }}
      >
        <motion.img
          src="/tooth.svg"
          alt="Tooth"
          className="w-full h-full opacity-[0.104] dark:opacity-[0.132] mix-blend-multiply dark:mix-blend-screen blur-[2px]"
          animate={{
            rotate: [-3, 3, -3],
            scale: [0.98, 1.02, 0.98]
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </motion.div>
    </>
  );
};

export default DentalAnimation;
